import { render } from "./ResourceLoadingIndicator.vue?vue&type=template&id=16594b2c&scoped=true"
import script from "./ResourceLoadingIndicator.vue?vue&type=script&lang=js"
export * from "./ResourceLoadingIndicator.vue?vue&type=script&lang=js"

import "./ResourceLoadingIndicator.vue?vue&type=style&index=0&id=16594b2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16594b2c"]])

export default __exports__